import { Star, Quote, CheckCircle2 } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "María Fernández",
    role: "Reforma integral de vivienda",
    location: "Cunit",
    rating: 5,
    text:
      "Un equipo puntual, limpio y muy profesional. Reformaron nuestra casa entera en el plazo acordado y con un acabado impecable. Recomendables 100%.",
    initial: "MF",
  },
  {
    name: "Jordi Rovira",
    role: "Rehabilitación de fachada",
    location: "Calafell",
    rating: 5,
    text:
      "La comunidad quedó encantada con el resultado de la fachada. Presupuesto claro desde el primer día, sin sorpresas ni sobrecostes al finalizar.",
    initial: "JR",
  },
  {
    name: "Anna Martí",
    role: "Obra nueva unifamiliar",
    location: "El Vendrell",
    rating: 5,
    text:
      "Construyeron nuestra casa desde cero. Trato cercano, atentos a cada detalle y siempre dispuestos a resolver cualquier duda durante la obra.",
    initial: "AM",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-28 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#F26522]/10 text-[#D95212] text-xs font-mono-accent uppercase tracking-[0.18em] mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#F26522]" />
            Testimonios
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1528] tracking-tight leading-[1.05]">
            Lo que dicen nuestros{" "}
            <span className="text-[#F26522]">clientes</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-white rounded-2xl p-7 border border-slate-200 lift"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#F26522]/15" />

              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#F26522] text-[#F26522]" />
                ))}
              </div>

              <p className="text-slate-700 leading-relaxed text-[15px] mb-6">
                &ldquo;{t.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-5 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-[#0B1528] text-white font-display font-bold flex items-center justify-center">
                  {t.initial}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-1.5">
                    <span className="font-semibold text-[#0B1528] text-sm">{t.name}</span>
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#25D366]" />
                  </div>
                  <div className="text-xs text-slate-500">
                    {t.role} · {t.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
